import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { TQC5010_R01Dto } from './Dto_TQC5010_R01';
import { TQC5010_R01Filter } from './Store_TQC5010_R01';

const baseUrl = `${config.apiUrl}/TQC5010_R01`;

/** 검색 조건에 맞는 검사항목 목록을 조회한다. */
export const getTQC5010_R01List = async (
	option: string,
	params: Partial<TQC5010_R01Filter>,
	listLength: number = 0
) => getData<ResponseDto<TQC5010_R01Dto[]>>(`${baseUrl}/${option}`, {
	params: { ...params, listLength } as TQC5010_R01Filter,
});

/** 검색 조건에 해당하는 검사항목 전체 건수를 조회한다. */
export const getTQC5010_R01AllCount = async (params: Partial<TQC5010_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: params as TQC5010_R01Filter });

    /** 검색 조건에 맞는 검사항목 목록을 엑셀로 내려받는다. */
export const downloadExcel_TQC5010_R01 = async (params: Partial<TQC5010_R01Filter>) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params: params as TQC5010_R01Filter });

/** 신규 검사항목을 다건 등록한다. */
export const postTQC5010_R01 = async (dtoList: TQC5010_R01Dto[]) =>
	postData<TQC5010_R01Dto[], ResponseDto<TQC5010_R01Dto[]>>(baseUrl, dtoList);

/** 수정된 검사항목을 다건 저장한다. */
export const patchTQC5010_R01 = async (dtoList: TQC5010_R01Dto[]) =>
	patchData<TQC5010_R01Dto[], ResponseDto<TQC5010_R01Dto[]>>(baseUrl, dtoList);

/** 복합 PK(검사항목그룹 + 검사기준코드) 기준으로 검사항목을 삭제한다. */
export const deleteTQC5010_R01 = async (dto: TQC5010_R01Dto) =>
	deleteData<ResponseDto<void>>(baseUrl, { data: dto });
